import { render } from "./OrganizerWorkspaceTopbar.vue?vue&type=template&id=1c1cec49&scoped=true"
import script from "./OrganizerWorkspaceTopbar.vue?vue&type=script&lang=js"
export * from "./OrganizerWorkspaceTopbar.vue?vue&type=script&lang=js"

import "./OrganizerWorkspaceTopbar.vue?vue&type=style&index=0&id=1c1cec49&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1cec49"]])

export default __exports__